import React, { useState } from 'react'
import LoginFormHCT from '../HCT components/HCT Login/LoginFormHCT'
import { useNavigate } from 'react-router-dom'

const LoginHCTPage = () => {

    return (
        <div>
            <LoginFormHCT />
        </div>
    )
}

export default LoginHCTPage
